import React from 'react';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import moment from 'moment';
import Popover from 'material-ui/Popover';
import { Menu } from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem/MenuItem';
import { tableStyles } from '../../../theme/AllocateBaseTheme';
import { convertToHoursAndMin } from '../../../utils/datetimeconverter';
import globals from '../../../globals/communityGlobals';

const locale = globals.getArea('dashboard');

export default class TeamsAvailabilityTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCheckboxes: false,
      open: false,
      popoverCounter: 0,
      popoverLabel: '',
    };
  }

  getTeamAvailabilityForSingleDayFormTable = (tableRow, tableCol) => {
    const row = Math.trunc(tableRow / 4);
    const col = tableCol - 1;
    const teamsAvailabiliy = this.props;
    return teamsAvailabiliy[row].teamAvailability[col];
  };

  computeTreatmentsCount = (tableRow, tableCol) =>
    this.getTeamAvailabilityForSingleDayFormTable(tableRow, tableCol).treatmentsCount;

  computeNpasCount = (tableRow, tableCol) =>
    this.getTeamAvailabilityForSingleDayFormTable(tableRow, tableCol).nonPatientActivitiesCount;

  openPopOverForTreatments = (rowNumber, columnId, target) => {
    this.setState({
      open: true,
      anchorEl: target,
      popoverCounter: this.computeTreatmentsCount(rowNumber, columnId),
      popoverLabel: locale.getMsg('totalTreatmentText'),
    });
  };

  openPopOverForNpas = (rowNumber, columnId, target) => {
    this.setState({
      open: true,
      anchorEl: target,
      popoverCounter: this.computeNpasCount(rowNumber, columnId),
      popoverLabel: locale.getMsg('totalNonPatientAssignmentsText'),
    });
  };

  handleCellClick = (rowNumber, columnId, event) => {
    // This prevents ghost click.
    event.preventDefault();
    if (columnId !== 0) {
      switch (rowNumber % 4) {
        case 1:
          this.openPopOverForTreatments(rowNumber, columnId, event.currentTarget);
          break;
        case 2:
          this.openPopOverForNpas(rowNumber, columnId, event.currentTarget);
          break;
        default:
          this.closePopover();
      }
    }
  };

  closePopover = () => {
    this.setState({
      open: false,
    });
  };

  handleRequestClose = () => {
    this.closePopover();
  };

  generateHeaderRows = headerData => {
    const headers = [];
    headers.push(<TableHeaderColumn key={0} className="fixed-header" />);
    for (let col = 0; col < headerData.length; col += 1) {
      const key = col + 1;
      headers.push(
        <TableHeaderColumn key={key} className="data-header">
          {moment(headerData[col].relevantDate).format('MMM Do')}
        </TableHeaderColumn>,
      );
    }

    return headers;
  };

  generateTeamRows = teamsAvailabiliy => {
    const teamRows = [];
    Object.keys(teamsAvailabiliy).forEach((k, t) => {
      const availableRow = [];
      const requiredTreatmentsTimeRow = [];
      const requiredNonPatientActivitiesTimeRow = [];
      const requiredTotalTimeRow = [];
      const team = teamsAvailabiliy[t];
      const teamName = team.teamName;

      availableRow.push(
        <TableRowColumn className="titled-cell" key={`availableRow-${teamName}-title-column`}>
          <ul>
            <li>
              <b>{teamName}</b>
            </li>
            <li>{locale.getMsg('availabilityListRow')}</li>
          </ul>
        </TableRowColumn>,
      );

      requiredTreatmentsTimeRow.push(
        <TableRowColumn key={`requiredTreatmentsTimeRow-${k}-title-column`} className="titled-cell required">
          {locale.getMsg('treatmentTimeRequiredListRow')}
        </TableRowColumn>,
      );
      requiredNonPatientActivitiesTimeRow.push(
        <TableRowColumn key={`requiredNonPatientActivitiesTimeRow-${k}-title-column`} className="titled-cell required">
          {locale.getMsg('npasTimeRequireddListRow')}
        </TableRowColumn>,
      );
      requiredTotalTimeRow.push(
        <TableRowColumn key={`requiredTotalTimeRow-${k}-title-column`} className="titled-cell required">
          {locale.getMsg('totalTimeRequiredListRow')}
        </TableRowColumn>,
      );

      team.teamAvailability.forEach(singleDayTeamAvailability => {
        availableRow.push(
          <TableRowColumn
            key={`availableRow-${teamName}-column-totalAvailableHours-${singleDayTeamAvailability.relevantDate}`}
          >
            {convertToHoursAndMin(singleDayTeamAvailability.totalAvailableHours)}
          </TableRowColumn>,
        );

        requiredTreatmentsTimeRow.push(
          <TableRowColumn
            key={`availableRow-${teamName}-column-treatmentMinutesRequired-${singleDayTeamAvailability.relevantDate}`}
          >
            {convertToHoursAndMin(singleDayTeamAvailability.treatmentMinutesRequired)}
          </TableRowColumn>,
        );

        requiredNonPatientActivitiesTimeRow.push(
          <TableRowColumn
            key={`availableRow-${teamName}-column-nonPatientActivityMinutesRequired-${singleDayTeamAvailability.relevantDate}`}
          >
            {convertToHoursAndMin(singleDayTeamAvailability.nonPatientActivityMinutesRequired)}
          </TableRowColumn>,
        );

        requiredTotalTimeRow.push(
          <TableRowColumn
            key={`availableRow-${teamName}-column-requiredTotalTimeRow-${singleDayTeamAvailability.relevantDate}`}
          >
            {convertToHoursAndMin(singleDayTeamAvailability.totalMinutesRequired)}
          </TableRowColumn>,
        );
      });
      const className = t % 2 === 0 ? 'headRole available' : '';

      teamRows.push(
        <TableRow style={{ textAlign: 'center' }} className={className} key={`${teamName}-teamAvailabilities`}>
          {availableRow}
        </TableRow>,
      );
      teamRows.push(
        <TableRow style={{ textAlign: 'center' }} key={`${teamName}-treatments`} className="required-row">
          {requiredTreatmentsTimeRow}
        </TableRow>,
      );
      teamRows.push(
        <TableRow style={{ textAlign: 'center' }} key={`${teamName}-npa`} className="required-row">
          {requiredNonPatientActivitiesTimeRow}
        </TableRow>,
      );
      teamRows.push(
        <TableRow style={{ textAling: 'center' }} key={`${teamName}-total`} className="required-row">
          {requiredTotalTimeRow}
        </TableRow>,
      );
    });

    return teamRows;
  };

  render() {
    const teamsAvailability = this.props;
    return (
      <div className="teams-availability-table">
        <Table onCellClick={this.handleCellClick} headerStyle={tableStyles.headerStyle}>
          <TableHeader displaySelectAll={this.state.showCheckboxes} className="table-header">
            <TableRow className="header-row">{this.generateHeaderRows(teamsAvailability[0].teamAvailability)}</TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={this.state.showCheckboxes} className="table-content">
            {this.generateTeamRows(teamsAvailability)}
          </TableBody>
        </Table>
        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'left', vertical: 'top' }}
          onRequestClose={this.handleRequestClose}
        >
          <Menu style={{ textAlign: 'center' }}>
            <h1>{this.state.popoverCounter}</h1>
            <MenuItem primaryText={this.state.popoverLabel} />
          </Menu>
        </Popover>
      </div>
    );
  }
}
